/****
 * 2022-01-01 CHP 增加: 标识是否启用VIP功能
 * 2022-01-01 CHP 增加: 标识Bonus领取类型 1 部分领取 2 全部领取
 * 2022-06-12 CHP 增加: 标识现金召回相关属性
 * 2022-09-17 Matt 强弹图调整 Trello#113
 * 2022-10-02 HHY 只要用户当日未领取7天送，则强弹7天送3次，之后再强弹转盘游戏
 */
import Vue from 'vue'
import Vuex from 'vuex'
import {getTimeSpanString} from '@/utils'

Vue.use(Vuex)

const defaultModals = [
  {name: 'days7Gift', showing: false, updateDateSpan: (new Date()).getTime(), maxPopupTimes: 1, popupTimes: 0}, // 0
  {name: 'firstDeposit', showing: false, updateDateSpan: (new Date()).getTime(), maxPopupTimes: 3, popupTimes: 0}, // 1
  {name: 'depositCallback', showing: false, updateDateSpan: (new Date()).getTime(), maxPopupTimes: 3, popupTimes: 0}, // 2
  {name: 'regularActivity', showing: false, updateDateSpan: (new Date()).getTime(), maxPopupTimes: -3, popupTimes: 0}, // 3 目前是5周年
  {name: '', showing: false, updateDateSpan: null, maxPopupTimes: 0, popupTimes: 1}, // 4
  {name: 'JiliActivity', showing: false, updateDateSpan: (new Date()).getTime(), maxPopupTimes: -3, popupTimes: 0}, // 5
  {
    name: 'WheelDiscount',
    showing: false,
    updateDateSpan: (new Date()).getTime(),
    maxPopupTimes: 999999999,
    popupTimes: 0
  }, // 6
  {name: 'WheelTask', showing: false, updateDateSpan: (new Date()).getTime(), maxPopupTimes: 999999999, popupTimes: 0}, // 7
  {
    name: 'TimeLimitDeposit',
    showing: false,
    updateDateSpan: (new Date()).getTime(),
    maxPopupTimes: 999999999,
    popupTimes: 0
  }, // 8
  {name: 'JiliActivity2', showing: false, updateDateSpan: (new Date()).getTime(), maxPopupTimes: -3, popupTimes: 0}, // 9
  {name: 'VipBenefits', showing: false, updateDateSpan: (new Date()).getTime(), maxPopupTimes: 3, popupTimes: 0}] // 10

let modelsFromLocalStorage = defaultModals
const state = {
  hostGet: '19',
  hostRate: '+20%',
  vipEnable: false, // 2022-01-01 CHP 增加: 标识是否启用VIP功能
  bonusConvertType: 1, // 2022-01-01 CHP 增加: 标识Bonus领取类型 1 部分领取 2 全部领取
  isAndroidBrowser: false,
  showLoading: false,
  watchedCid: ['5s5rcl'], // 2023-12-12 YTW 监听行为渠道号5s5rcl
  currentRoute: '',
  balance: {},
  newMail: false,
  userName: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).UserName : '',
  verifyInfo: null,
  bankList: [],
  giftCollectInfo: null,
  hideGiftPop: true, // 2022-11-24 HHY 7天送改为默认不弹出
  giftIconClicked: false, // 标记是不是点击右下解图标打开的7日弹框图
  userFirstDeposit: false, // 2022-10-29 HHY 由hideBonusPop改为userFirstDeposit;从数据库中判断用户是否为首充
  showLeftMenu: false,
  showDepositBonusIcon: false,
  showFirstDepositPop: false, // 2022-11-12 HHY 增加，控制HOME页的首充弹窗组件的显示隐藏
  getTimeSpanString,
  depositBonusStartTime: null,
  depositBonusElapseTimeStr: '00:00:00',
  showGiftIcon: false,
  show5thIcon: false,
  hasNewApkVersion: false,
  hideVersionUpdatePop: false,
  hidePromotionPop: true,
  isAppCid: false,
  finishUserGuide: localStorage.getItem('finishUserGuide'),
  internation: localStorage.getItem('internation') ? localStorage.getItem('internation') : 'IN',
  internationName: localStorage.getItem('internationName') ? localStorage.getItem('internationName') : 'भारत',
  locale: localStorage.getItem('locale') ? localStorage.getItem('locale') : 'EN',
  loginStatus: 'login',
  showInternationDDL: true,
  showNoticePop: false,
  maintenanceState: false,
  isLoadingGiftInfo: false,
  callbackTimeSpan: 0,
  hideCallbackPop: false,
  callbackCashTimeSpan: 0,
  showBonusHint: true,
  lastCheckCallback: 0,
  lastLogTime: 0,
  tournament: { // 2022-07-22HHY创建
    comeFromTournament: false,
    categoryFromTournament: '',
    selectedActivityCode: '', // 因为周三会有两个游戏类活动并列显示，所以创建了它和下面两个参数
    selectedCategory: ''
  },
  bigRparam: {
    isBigRuser: false,
    bigRconfig: '', // 大R配置信息，Json格式 2022-09-25 HHY
    useBigRconfig: false // 是否在充值界面使用大R的充值额范围等信息
  },
  bigRpopupShow: false, // 是否弹出强弹图
  confirmWinShow: false, // 2022-09-26 HHY添加
  showGiftPopNotSelfMadeGame: true, // 默认先显示7天送，待当日领取7天送后再显示转盘游戏 2022-10-02 HHY
  fromLoggedIn: false, // 2022-10-08 HHY 判断是否来自登录注册页面，用于使得7天送和首充弹窗依次弹出
  is7DaysGiftPopClosed: false, // 2022-10-08 HHY 如果是来自登录注册页面，先弹出7天送，关闭7天送通知首充弹出
  hasCashBonus: false, // 2022-11-20 从menu组件中移入
  msgCount: 0,
  msgCountFresh: false,
  modals: modelsFromLocalStorage || defaultModals, // 按顺序待显示的弹框
  currentModalIndex: null, // 当前显示的弹框索引
  membersDayDeposit: false,
  userOnGame: false,
  giftShowRedCircle: false
}

const mutations = {
  toggleLoading (state, status) {
    state.showLoading = status
    return state.showLoading
  },
  setCurrentRoute (state, type) {
    state.currentRoute = type
    return state.currentRoute
  },
  setBalance (state, balance) {
    state.balance = balance
    return state.balance
  },
  setNewMail (state, newMail) {
    state.newMail = newMail
    return state.newMail
  },
  updateUserName (state, userName) {
    state.userName = userName
    return state.userName
  },
  setUserVerifyInfo (state, verifyInfo) {
    state.verifyInfo = verifyInfo
    return state.verifyInfo
  },
  setUserBankList (state, bankList) {
    state.bankList = bankList
    return state.bankList
  },
  setUserFirstDeposit (state, userFirstDeposit) {
    state.userFirstDeposit = userFirstDeposit
    return state.userFirstDeposit
  },
  set5thIcon (state, isShow) {
    state.show5thIcon = isShow
  },
  setGiftCollectInfo (state, giftCollectInfo) {
    state.giftCollectInfo = giftCollectInfo
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    state.depositBonusStartTime = (new Date()).getTime()
    if (userInfo) {
      // 2022-03-29 24小时内充值送不再限定24小时内，首充即可
      // 2022-11-30 HHY 重新显示首充优惠在充值页面
      if (giftCollectInfo.depositCount > 0 || giftCollectInfo.isDeposited) { // 用户以前充过值
        state.showDepositBonusIcon = false
        state.userFirstDeposit = false
        state.showFirstDepositPop = false
      } else {
        state.showDepositBonusIcon = true
        state.userFirstDeposit = true // 让首充弹窗弹出（或者用户为首充）
        state.showFirstDepositPop = true
      }
      if (userInfo.CreateTimeSpan !== undefined) { // 用户注册时间与19700101之间的毫秒级总数
        let elapseTimeSpan = state.depositBonusStartTime - userInfo.CreateTimeSpan
        state.depositBonusElapseTimeStr = getTimeSpanString(elapseTimeSpan)

        if (giftCollectInfo.hasGiftLeft) {
          state.showGiftIcon = true
        } else {
          state.showGiftIcon = false
        }
        // 2023-06-05 YTW
        if (giftCollectInfo.hasGiftLeft) { // 只要当日还未领取
          if (giftCollectInfo.numberOfDay < 7 && (giftCollectInfo.mayCollectDeposit || giftCollectInfo.mayCollectFree)) { // 只要有未领取就弹出
            state.hideGiftPop = false
            state.showGiftIcon = true
            state.showGiftPopNotSelfMadeGame = false
            sessionStorage.setItem('showGiftPopNotSelfMadeGame', state.showGiftPopNotSelfMadeGame)
          } else {
            state.hideGiftPop = true
            state.showGiftIcon = true
            state.showGiftPopNotSelfMadeGame = true
            sessionStorage.setItem('showGiftPopNotSelfMadeGame', state.showGiftPopNotSelfMadeGame)
          }
        } else {
          state.hideGiftPop = true
          state.showGiftIcon = true
          state.showGiftPopNotSelfMadeGame = false
          sessionStorage.setItem('showGiftPopNotSelfMadeGame', state.showGiftPopNotSelfMadeGame)
        }
      } else {
        state.showNoticePop = true
      }
    } else {
      state.showNoticePop = false
      let elapseTimeSpan = state.depositBonusStartTime - (new Date()).getTime()
      state.depositBonusElapseTimeStr = getTimeSpanString(elapseTimeSpan)
    }
    state.showGiftIcon = giftCollectInfo.showGiftIcon
    return state.showGiftPop
  },
  setHideGiftPop (state, hideGiftPop) {
    state.hideGiftPop = hideGiftPop

    // START 2022-10-02 HHY 用户若当日将7天送已领取或7天送强弹已3次，则强弹出转盘游戏
    if (state.giftCollectInfo) {
      let collectedTime = localStorage.getItem('7DayBonusTodayCollected')
      let now = new Date(new Date().toDateString()).getTime()
      if (state.giftCollectInfo.hasGiftLeft && (collectedTime == null || now > collectedTime)) { // 只要本日还未领取
        const giftPopupTimesOfToday = JSON.parse(localStorage.getItem('sevenDaysGiftPopupTimesOfToday'))
        if (giftPopupTimesOfToday &&
          giftPopupTimesOfToday.popupDay === new Date().toDateString() &&
          giftPopupTimesOfToday.times >= 3) { // 只要用户当日没领取，每天强弹3次 2022-10-02 HHY
          state.showGiftPopNotSelfMadeGame = false
          sessionStorage.setItem('showGiftPopNotSelfMadeGame', state.showGiftPopNotSelfMadeGame)
          state.showGiftIcon = true
        } else {
          state.showGiftPopNotSelfMadeGame = true
          sessionStorage.setItem('showGiftPopNotSelfMadeGame', state.showGiftPopNotSelfMadeGame)
          state.showGiftIcon = true
        }
      } else {
        state.showGiftPopNotSelfMadeGame = false
        sessionStorage.setItem('showGiftPopNotSelfMadeGame', state.showGiftPopNotSelfMadeGame)
        state.showGiftIcon = false
      }
    }
    // END 2022-10-02 HHY 用户若当日将7天送已领取或7天送强弹已3次，则强弹出转盘游戏
    return state.hideGiftPop
  },
  setShowGiftIcon (state, showGiftIcon) {
    state.showGiftIcon = showGiftIcon
    return state.showGiftIcon
  },
  setGiftShowRedCircle (state, showRedCircle) {
    state.giftShowRedCircle = showRedCircle
    return state.giftShowRedCircle
  },
  setShowLeftMenu (state, showLeftMenu) {
    state.showLeftMenu = showLeftMenu
    return state.showLeftMenu
  },
  setHideVersionUpdatePop (state, hideVersionUpdatePop) {
    state.hideVersionUpdatePop = hideVersionUpdatePop
    return state.hideVersionUpdatePop
  },
  setHasNewApkVersion (state, hasNewApkVersion) {
    state.hasNewApkVersion = hasNewApkVersion
    state.hideVersionUpdatePop = false
    return state.hasNewApkVersion
  },
  setHidePromotionPop (state, hidePromotionPop) {
    state.hidePromotionPop = hidePromotionPop
    return state.hidePromotionPop
  },
  setIsAppCid (state, isAppCid) {
    state.isAppCid = isAppCid
    return state.isAppCid
  },
  setMaintenanceState (state, maintenanceState) {
    console.log('setMaintenance state: ' + maintenanceState)
    state.maintenanceState = maintenanceState
    return state.maintenanceState
  },
  setFinishUserGuide (state, finishUserGuide) {
    state.finishUserGuide = finishUserGuide
    return state.finishUserGuide
  },
  // 2021-08-29 C007 设置国家代码
  setInternation (state, internation) {
    state.internation = internation
    localStorage.setItem('internation', internation)
    switch (internation) {
      case 'IN':
        state.loginStatus = 'login'
        break
      case 'INT':
        state.loginStatus = 'loginEmail'
    }
    return state.internation
  },
  // 2021-10-25 CHP 设置国家名称
  setInternationName (state, internationName) {
    state.internationName = internationName
    localStorage.setItem('internationName', internationName)
    return state.internation
  },
  // 2021-10-25 CHP 设置国家语言
  setLocale (state, locale) {
    state.locale = locale
    localStorage.setItem('locale', locale)
    return state.locale
  },
  // 2021-10-25 CHP 设置登录页状态标识
  setLoginStatus (state, status) {
    state.loginStatus = status
    return state.loginStatus
  },
  setShowInternationDDL (state, showInternationDDL) {
    state.showInternationDDL = showInternationDDL
    localStorage.setItem('showInternationDDL', showInternationDDL)
    return state.showInternationDDL
  },
  // 2021-11-13 CHP 设置显示公告弹框
  setShowNoticePop (state, showNoticePop) {
    state.showNoticePop = showNoticePop
    return state.showNoticePop
  },
  setGiftLoadingInfoStatus (state, isGiftLoading) {
    state.isLoadingGiftInfo = isGiftLoading
    return state.isLoadingGiftInfo
  },
  setCallbackTimeSpan (state, callbackTimeSpan) {
    state.callbackTimeSpan = callbackTimeSpan
    return state.callbackTimeSpan
  },
  setHideCallbackPop (state, hideCallbackPop) {
    state.hideCallbackPop = hideCallbackPop
    return state.hideCallbackPop
  },
  setLastCheckCallback (state, lastCheckCallback) {
    state.lastCheckCallback = lastCheckCallback
    return state.lastCheckCallback
  },
  setLastLogTime (state, lastLogTime) {
    state.lastLogTime = lastLogTime
    return state.lastLogTime
  },
  setFromLoggedIn (state, isFromLoggedIn) {
    state.fromLoggedIn = isFromLoggedIn
    return state.fromLoggedIn
  },
  set7DaysGiftClosed (state, isClosed) {
    state.is7DaysGiftPopClosed = isClosed
    return state.is7DaysGiftPopClosed
  },
  setIfShowFirstDepositPop (state, showFirstDepositPop) {
    state.showFirstDepositPop = showFirstDepositPop
    return state.showFirstDepositPop
  },
  setIfHaveCashOrBonus (state, hasCashBonus) {
    state.hasCashBonus = hasCashBonus
    return state.hasCashBonus
  },
  setMsgCount (state, hasCashBonus) {
    state.msgCount = hasCashBonus
    return state.msgCount
  },
  setMsgCountFresh (state, msgCountFresh) {
    state.msgCountFresh = msgCountFresh
    return state.msgCountFresh
  },
  setModals (state, modals) {
    state.modals = modals
    return state.modals
  },
  setCurrentModalIndex (state, currentModalIndex) {
    state.currentModalIndex = currentModalIndex
    return state.currentModalIndex
  },
  setGiftIconClicked (state, giftIconClicked) {
    state.giftIconClicked = giftIconClicked
    return state.giftIconClicked
  },
  setMembersDayDeposit (state, membersDayDeposit) {
    state.membersDayDeposit = membersDayDeposit
    return state.membersDayDeposit
  },
  setUserOnGame (state, userOnGame) {
    state.userOnGame = userOnGame
    return state.userOnGame
  },
  setBigRConfig (state, bigRConfig) {
    if (!state.bigRparam) {
      state.bigRparam = {
        isBigRuser: false,
        bigRconfig: '',
        useBigRconfig: false
      }
    }
    state.bigRparam.bigRconfig = bigRConfig
    return state.bigRparam.bigRconfig
  },
  setIsBigRUser (state, isBigRUser) {
    state.bigRparam.isBigRuser = isBigRUser
    return state.bigRparam.isBigRuser
  },
  setBigRPopupShow (state, bigRPopupShow) {
    state.bigRpopupShow = bigRPopupShow
    return state.bigRpopupShow
  },
  setIsAndroidBrowser (state, isAndroidBrowser) {
    state.isAndroidBrowser = isAndroidBrowser
    return state.isAndroidBrowser
  }
}

export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/store.js